import { render, staticRenderFns } from "./modelChange.vue?vue&type=template&id=33c09838&scoped=true"
import script from "./modelChange.vue?vue&type=script&lang=js"
export * from "./modelChange.vue?vue&type=script&lang=js"
import style0 from "./modelChange.vue?vue&type=style&index=0&id=33c09838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c09838",
  null
  
)

export default component.exports